<template>
    <component :is="componentTag" v-if="isVisible" :id="link.customId || id" class="cms-link" v-on="$listeners" :to="to"
        :href="href" :target="target" @click="onClick">
        <template v-if="isDisplayingReview">
            <span class="review-debug f-9"><i class="fas fa-link" /> {{ link.displayName }}</span>
        </template>
        <slot name="before" />
        <slot></slot>
        <slot name="after" />
    </component>
</template>

<script>
// cms-link #hot-reload-debug
import CmsLink from "@/helpers/cms/CmsLink.js";

export default {
    name: `cms-link`,
    props: {
        link: { type: [Object, String] },
        id: { type: String },
        inMainMenu: { type: Boolean },
        navItem: { type: Boolean }
    },
    computed: {
        componentTag() {
            if (this.navItem) {
                return `b-nav-item`;
            } else if (this.to) {
                return `router-link`;
            } else if (this.href) {
                return `a`;
            } else {
                return `div`;
            }
        },
        // ensure that page link are always up-to-date
        cmsLink() {
            if (this.link) {
                return new CmsLink(this.link);
            } else {
                return this.link;
            }
        },
        to() {
            if (this.isEditMode || !this.cmsLink) {
                return null;
            }

            let link = this.cmsLink.to;
            if (this.cmsLink.params) {
                if (link.indexOf(`?`) > 0) {
                    link += this.cmsLink.params;
                } else {
                    link += `?${this.cmsLink.params}`;
                }
            }
            return link;
        },
        href() {
            if (this.isEditMode || !this.cmsLink) {
                return null;
            }

            if (this.to) {
                return `${window.location.origin}${this.to}`;
            }

            let link = this.cmsLink.href;
            if (this.cmsLink.params) {
                if (link.indexOf(`?`) > 0) {
                    link += this.cmsLink.params;
                } else {
                    link += `?${this.cmsLink.params}`;
                }
            }
            return link;
        },
        target() {
            if (this.to || !this.cmsLink) {
                return null;
            }
            return this.cmsLink.openInNewTab ? `_blank` : ``;
        },
        isVisible() {
            if (!this.cmsLink) {
                console.error(`Link missing for CMS link`, this);
                return true;
            }

            if (this.cmsLink.type === `collapse` && !this.inMainMenu) {
                return false;
            } else if (this.cmsLink.type === `wheelchair` && !this.isKioskDevice) {
                return false;
            } else if (this.cmsLink.type === `offline`) {
                if (this.isKioskDevice) {
                    return !window.navigator.onLine;
                } else {
                    return false;
                }
            } else if (this.cmsLink.type === `collapse` && !this.isMobileLayoutOrPreview) {
                return false;
            }

            if (!this.cmsLink.mediaQuery) {
                return true;
            } else {
                return this.cmsLink.mediaProxy.visible;
            }
        },
    },
    methods: {
        onClick() {
            if (this.isEditMode || !this.cmsLink)
                return;

            switch (this.cmsLink.type) {
                case `back`:
                    window.history.go(-1);
                    break;
                case `next`:
                    window.history.go(1);
                    break;
                case `collapse`:
                    this.$emit(`collapse-nav-menu`);
                    break;
                case `offline`:
                    window.location.reload();
                    break;
                case `wheelchair`:
                    this.$store.commit(`setAccessibilityWheelchair`, !this.$store.state.accessibility.wheelchair);
                    break;
                case `feedback`:
                    this.$store.commit(`showFeedbackModal`, {action: `nav-link`});
                    break;
                case `language`:
                    this.$store.state.languageSelectModal = true;
                    break;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
